// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PdfSettingsBySalesEntityController = function ($rootScope, $http, $scope, Fonts, gettext, gettextCatalog, PdfTemplateDownload, Features, salesEntitiesService, GeneralEmailSettings, NormalizedInvoiceReferenceType, CommonObjects) {

    const firstPageTemplateName = "firstPageTemplate";
    const followingPagesTemplateName = "nextPagesTemplate";

    $scope.accountLink = "/#/account-settings/company";
    $scope.settingsLoaded = false;
    $scope.allowedFontsSizeArray = [
        { value: 9, label: "9px" },
        { value: 10, label: "10px" },
        { value: 11, label: "11px" },
        { value: 12, label: "12px" },
        { value: 13, label: "13px" },
        { value: 14, label: "14px" },
        { value: 15, label: "15px" },
        { value: 16, label: "16px" }];
    $scope.selectedTab = "settings";
    $scope.QRInvoiceType = Object.freeze({
        IBANCreditorReference: 'IBANCreditorReference',
        QRIBANQRReference: 'QRIBANQRReference'
    });
    $scope.selectedInvoiceType = {
        value: $scope.QRInvoiceType.IBANCreditorReference
    };
    $scope.features = Features.features;
    $scope.fonts = Fonts.query();
    $scope.salesEntities = [];
    $scope.salesEntityId = null;
    $scope.salesEntityDefault = null;

    $scope.settingsLoaded == false;

    $scope.baseSaleEntitiesUrl = '/api/v1/salesEntities/';

    $scope.firstPageTemplateAttachment = setupBlankAttachment();
    $scope.nextPagesTemplateAttachment = setupBlankAttachment();
    $scope.isError = false;
    $scope.errorMessage = '';
    $scope.chosenFileBaseText = 'No file chosen';
    $scope.chosenFileTextFirstPage = gettextCatalog.getString(gettext($scope.chosenFileBaseText));
    $scope.chosenFileTextNextPages = gettextCatalog.getString(gettext($scope.chosenFileBaseText));

    $scope.template = GeneralEmailSettings.get({}, function () {
        if ($scope.template.NormalizedInvoiceReference !== NormalizedInvoiceReferenceType.Off) {
            $scope.isReferenceNumberEnabled = true;
        }
    });

    salesEntitiesService.query({}, function (response) {
        $scope.salesEntities = response;

        if ($scope.salesEntities.length > 0) {
            $scope.settingsLoaded = true;
        }

        $scope.salesEntityDefault = $scope.salesEntities.find(function (el) {
            return el.IsDefault == true;
        });
        $scope.salesEntityCurrent = $scope.salesEntityDefault;

        $scope.pdfSettings = $scope.salesEntityCurrent.PdfSettings;

        if ($scope.salesEntityDefault) {
            let defaultSuffix = " (" + gettextCatalog.getString(gettext('default')) + ")";
            $scope.salesEntityDefault.InternalName += defaultSuffix;
            $scope.salesEntityId = $scope.salesEntityDefault.Id;
        }

        onChangedSalesEntity($scope.salesEntityCurrent.PdfSettings);

    });
    $scope.$watch('salesEntityId', function (newSalesEntityId, oldSalesEntityId) {

        if ($scope.settingsLoaded) {
            $scope.salesEntityCurrent = $scope.salesEntities.find(function (el) {
                return el.Id == newSalesEntityId;
            });
            $scope.pdfSettings = $scope.salesEntityCurrent.PdfSettings;
        }
    }, true);
    $scope.$watch('salesEntityCurrent.PdfSettings', function (newPdfSettings, oldPdfSettings) {
        onChangedSalesEntity(newPdfSettings);
    }, true);

    $scope.save = function () {
        if ($scope.useQRInvoice) {
            $scope.pdfSettings.QRInvoiceType = $scope.selectedInvoiceType.value;
        } else {
            $scope.pdfSettings.QRInvoiceType = null;
        };

        putPdfSettings();
        refetchPdfSettings();
    };

    $scope.uploadCompleted = function (content) {
        if (!content)
            return;

        if (content.status == "success") {
            $scope.notify("success", gettextCatalog.getString(gettext("PDF uploaded")));

            refetchPdfSettings();
        } else {
            $scope.notify("error", "Upload error: " + content.message);
        }
    };
        

    $scope.resetFirstPageFile = function () {
        confirm(gettextCatalog.getString(gettext('Delete')), function () {
            $scope.pdfSettings.FirstPageTemplate = null;
            $scope.save();
        });
    };

    $scope.resetFollowingPageFile = function () {
        confirm(gettextCatalog.getString(gettext('Delete')), function () {
            $scope.pdfSettings.NextPagesTemplate = null;
            $scope.save();
        });
    };

    $scope.download = function (templateName) {
        var downloadInfo = new PdfTemplateDownload();
        downloadInfo.$get({ salesEntityId: $scope.salesEntityId, templateName: templateName }, function () {
            window.location = downloadInfo.Url;
        });
    };

    $scope.getActionPath = function (page) {
        return $scope.baseSaleEntitiesUrl + $scope.salesEntityId + '/pdfSettings/templates/' + page + '/upload'
            + '?selected_legal_entity_id=' + encodeURIComponent($rootScope.chosenEntity.Id);
    };

    $scope.$watch('errorMessage', function (newValue) {
        if (newValue) {
            $scope.notify('error', 'Upload error: ' + newValue);
            $scope.errorMessage = '';
        }
    });

    $scope.$watch('firstPageTemplateAttachment', function (newValue, oldValue) {
        OnAttachmentChanged(firstPageTemplateName, newValue);
    }, true);

    $scope.$watch('nextPagesTemplateAttachment', function (newValue, oldValue) {
        OnAttachmentChanged(followingPagesTemplateName, newValue);
    }, true);
    
    $scope.onSuccessCallback = function () {
        $scope.uploadCompleted($scope.successResponse);
    };

    $scope.saveUpload = function (templateName) {
        $scope.successResponse = '';
        if ($scope.isSavingForbidden(templateName)) {
            $scope.errorMessage = 'Nothing to save yet. Please choose a file first.';
        } else {
            if (templateName === firstPageTemplateName) {
                $scope.saveFirstPageTemplate();
            }
            else if (templateName === followingPagesTemplateName) {
                $scope.saveNextPagesTemplate();
            }
        }
    };

    $scope.isSavingForbidden = function (templateName) {
        var fileName;
        if (templateName === firstPageTemplateName) {
            fileName = $scope.firstPageTemplateAttachment.Files['_c'].FileName;
        }
        else if (templateName === followingPagesTemplateName) {
            fileName = $scope.nextPagesTemplateAttachment.Files['_c'].FileName;
        }
        return (!fileName || fileName.length === 0);
    };
    
    $scope.getFileUploaderText = function () {
        return gettextCatalog.getString(gettext('Choose file'));
    };

    $scope.getChosenFileText = function (templateName, fileName) {
        if (templateName === firstPageTemplateName)
            $scope.chosenFileTextFirstPage = fileName ? fileName : gettextCatalog.getString(gettext($scope.chosenFileBaseText));
        else if (templateName === followingPagesTemplateName)
            $scope.chosenFileTextNextPages = fileName ? fileName : gettextCatalog.getString(gettext($scope.chosenFileBaseText));
    };

    $scope.dataInvalid = function (templateName) {
        return $scope.isSavingForbidden(templateName);
    };

    function OnAttachmentChanged(templateName, newValue) {
        if (newValue && newValue.Files && newValue.Files['_c'] && newValue.Files['_c'].FileName && newValue.Files['_c'].FileName.length > 0) {
            $scope.getChosenFileText(templateName, newValue.Files['_c'].FileName);
        }
        else {
            $scope.getChosenFileText(templateName, null);
        }
    };

    function onChangedSalesEntity(pdfSettings) {
        if (pdfSettings) {
            $scope.pdfSettings = pdfSettings;
            $scope.useQRInvoice = !!pdfSettings.QRInvoiceType;

            if ($scope.useQRInvoice) {
                $scope.selectedInvoiceType.value = pdfSettings.QRInvoiceType;
            } else {
                $scope.selectedInvoiceType.value = $scope.QRInvoiceType.IBANCreditorReference;
            }

            if ($scope.pdfSettings.PrintSenderAddress === false) {
                pdfSettings.IncludeVatId = false;
            }
        }

        resetFilesSelection();
    };

    function notifySavePdfSettingsSuccess() {
        $scope.notify("success", gettextCatalog.getString(gettext("Saved Successfully")));
    };

    function confirm(header, deleteCallback) {
        $scope.yesCancel(header, gettextCatalog.getString(gettext('Are you sure?')), function () { deleteCallback(); });
    };

    function putPdfSettings() {
        $http({
            method: "PUT",
            url: $scope.baseSaleEntitiesUrl + $scope.salesEntityId + "/pdfSettings",
            params: null,
            data: $scope.pdfSettings,
            headers: {},
            cache: false
        }).then(function (response) {
            notifySavePdfSettingsSuccess();
            if (response.data) {
                $scope.salesEntityCurrent.PdfSettings = response.data;
            }
        });
    };

    function refetchPdfSettings() {
        $http({
            method: "GET",
            url: $scope.baseSaleEntitiesUrl + $scope.salesEntityId + '/pdfSettings',
            params: null,
            data: null,
            headers: {},
            cache: false
        }).then(function (response) {
            if (response.data) {
                $scope.salesEntityCurrent.PdfSettings = response.data;
            }
        });
    };

    function resetFilesSelection() {
        $scope.firstPageTemplateAttachment = setupBlankAttachment();
        $scope.nextPagesTemplateAttachment = setupBlankAttachment();
    };

    function setupBlankAttachment() {
        return CommonObjects.BlankAttachment.get();
    };
};
PdfSettingsBySalesEntityController.$inject = ['$rootScope', '$http', '$scope', 'Fonts', 'gettext', 'gettextCatalog', 'PdfTemplateDownload', 'Features', 'SalesEntities', 'GeneralEmailSettings', 'NormalizedInvoiceReferenceType', 'CommonObjects'];
